// actionTypes.js
export const SET_VALUE_INVESTISSEMENT = "SET_VALUE_INVESTISSEMENT";
export const SET_CURRENT_PAGE_INVESTISSEMENT =
  "SET_CURRENT_PAGE_INVESTISSEMENT";
export const SET_ORDER_INVESTISSEMENT = "SET_ORDER_INVESTISSEMENT";
export const SET_SORT_FIELD_INVESTISSEMENT = "SET_SORT_FIELD_INVESTISSEMENT";
export const SET_PAGE_SIZE_INVESTISSEMENT = "SET_PAGE_SIZE_INVESTISSEMENT";
export const SET_CUSTOM_FILTERS_INVESTISSEMENT =
  "SET_CUSTOM_FILTERS_INVESTISSEMENT";
export const SET_SORTING_INVESTISSEMENT = "SET_SORTING_INVESTISSEMENT";
export const SET_ACTIVE_TAB_INVESTISSEMENT = "SET_ACTIVE_TAB_INVESTISSEMENT";
export const SET_QUERY_INVESTISSEMENT = "SET_QUERY_INVESTISSEMENT";
export const SET_ACTIF_INVESTISSEMENT = "SET_ACTIF_INVESTISSEMENT";
export const SET_SELECTED_OPTION_FILTERS_INVESTISSEMENT =
  "SET_SELECTED_OPTION_FILTERS_INVESTISSEMENT";
export const SET_SELECTED_OPTION_ID_INVESTISSEMENT =
  "SET_SELECTED_OPTION_ID_INVESTISSEMENT";
export const SET_COLUMN_INVESTISSEMENT = "SET_COLUMN_INVESTISSEMENT";
